module.exports = __webpack_public_path__ + "static/2_3_game-tree-2_EL-bd6498c1aabf89f5a5f07c51a46b1d3f.svg";